export default __webpack_public_path__ + "static/media/ic_recipe.9569f9f7.png";